import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
export function cn() {
    var inputs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        inputs[_i] = arguments[_i];
    }
    return twMerge(clsx(inputs));
}
export function decodeHTMLEntity(encodedString) {
    return encodedString.replace(/&#(\d+);/g, function (match, dec) {
        return String.fromCharCode(dec);
    });
}
export var formatIntlDecimal = function (value) {
    var number = parseFloat(value);
    if (isNaN(number))
        return value;
    return new Intl.NumberFormat("en-US", { style: "decimal" }).format(number);
};
